import { Form, Input } from "antd";
import PropTypes from "prop-types";

function FormSection({ title, description, children }) {
    return (
        <section className="min-w-0 rounded-2xl border border-[#f0f0f0] bg-white p-4 md:p-5">
            <header className="mb-4 text-left">
                <h3 className="fontbold !text-left text-base text-[#121212]">{title}</h3>
                {description && <p className="mt-1 text-sm text-gray-500">{description}</p>}
            </header>
            <div className="grid gap-x-4 sm:grid-cols-2">{children}</div>
        </section>
    );
}

FormSection.propTypes = {
    title: PropTypes.node.isRequired,
    description: PropTypes.node,
    children: PropTypes.node,
};

/** Employee form split into the same sections the details page shows. */
function EmployeeFormFields({ t, companyName = "", isCreate = false }) {
    const required = [{ required: true, message: t("employees.fillAllRequiredFields") }];

    return (
        <div className="flex min-w-0 flex-col gap-3">
            <FormSection title={t("employees.personalInformation")}>
                <Form.Item name="firstName" label={t("employees.firstName")} rules={required}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name="lastName" label={t("employees.lastName")} rules={required}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name="phone" label={t("employees.phone")}>
                    <Input type="tel" autoComplete="off" />
                </Form.Item>
                <Form.Item name="dateOfBirth" label={t("employees.dateOfBirth")}>
                    <Input placeholder={t("employees.dateOfBirthPlaceholder")} autoComplete="off" />
                </Form.Item>
            </FormSection>

            <FormSection
                title={t("employees.loginAccess")}
                description={isCreate ? t("employees.passwordCreateHint") : t("employees.passwordEditHint")}>
                <Form.Item
                    name="email"
                    label={t("employees.email")}
                    rules={[...required, { type: "email", message: t("employees.emailInvalid") }]}>
                    <Input type="email" autoComplete="off" />
                </Form.Item>
                <Form.Item
                    name="password"
                    label={isCreate ? t("employees.password") : t("employees.newPassword")}
                    rules={isCreate ? required : []}>
                    <Input.Password autoComplete="new-password" />
                </Form.Item>
            </FormSection>

            <FormSection title={t("employees.businessInformation")}>
                {isCreate ? (
                    <Form.Item label={t("employees.company")}>
                        <Input value={companyName} readOnly disabled />
                    </Form.Item>
                ) : (
                    <Form.Item name={["company", "name"]} label={t("employees.company")}>
                        <Input readOnly disabled />
                    </Form.Item>
                )}
                <Form.Item name="registrationNumber" label={t("employees.registrationNumber")}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name="taxNumber" label={t("employees.taxNumber")}>
                    <Input autoComplete="off" />
                </Form.Item>
            </FormSection>

            <FormSection title={t("employees.address")}>
                <Form.Item name={["address", "address"]} label={t("employees.addressLine1")}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name={["address", "address2"]} label={t("employees.addressLine2")}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name={["address", "city"]} label={t("employees.city")}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name={["address", "state"]} label={t("employees.state")}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name={["address", "country"]} label={t("employees.country")}>
                    <Input autoComplete="off" />
                </Form.Item>
                <Form.Item name={["address", "zip"]} label={t("employees.zipCode")}>
                    <Input autoComplete="off" />
                </Form.Item>
            </FormSection>
        </div>
    );
}

EmployeeFormFields.propTypes = {
    t: PropTypes.func.isRequired,
    companyName: PropTypes.string,
    isCreate: PropTypes.bool,
};

export default EmployeeFormFields;
